module.exports = __webpack_public_path__ + "static/media/outro_award_bg.4dfa7427.jpg";